import { render } from "./LoaderPage.vue?vue&type=template&id=3fc17656&scoped=true"
const script = {}

import "./LoaderPage.vue?vue&type=style&index=0&id=3fc17656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc17656"]])

export default __exports__